import type { SeriesBookingTimeConflict } from "../../../features/Schedule/schedule.types";

/**
 * Secondary line for a series time-edit conflict row.
 * Prefers the occupant name when privacy allows; otherwise the writer reason.
 */
export function seriesEditConflictRowSecondary(
  item: SeriesBookingTimeConflict,
  bookedBy: (name: string) => string
): string {
  if (item.occupantDisplayName) {
    return bookedBy(item.occupantDisplayName);
  }
  return item.reason;
}
